import type { AnalyticsSender } from '@funtech-int/yango-shared';
import { Selection } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import {
    MovieCardTabTitle,
    PromoOfferBadgeType,
    SelectionErrorType,
    SelectionImpressionEntity,
} from '@kinopoisk-int/evgen-web-events/web/named_enums';
import {
    selectionErrorRaised,
    selectionMovieImpressionWithCardSelectedV2,
    selectionMovieImpressionWithCardShowedV2,
    selectionShowed,
} from '@kinopoisk-int/evgen-web-events/web/selection';

import { normalizeItemPosition } from '@/shared/lib/analytics/selection';

export const createAnalyticsEvents = (eventSender: AnalyticsSender) => ({
    showed(selectionKey: string) {
        eventSender.sendOnce(selectionShowed, { selectionId: selectionKey ?? '-' });
    },
    error(selectionKey: string, title?: string) {
        eventSender.send(selectionErrorRaised, {
            selectionId: selectionKey ?? '-',
            selectionName: title ?? '-',
            errorType: SelectionErrorType.EmptySelection,
            errorTitle: '404',
            errorMessage: 'Not found',
            requestId: '-',
        });
    },
    createSelectionCardAnalyticsEvents(selection: Selection) {
        return {
            cardClicked(
                position: number,
                contentId: string,
                title: string,
                badgeType: PromoOfferBadgeType
            ) {
                eventSender.send(selectionMovieImpressionWithCardSelectedV2, {
                    uuid: contentId ?? '-',
                    title: title ?? '-',
                    entityType: SelectionImpressionEntity.MovieIcon,
                    cardPosition: normalizeItemPosition(position),
                    selectionId: selection.key ?? '-',
                    selectionName: selection.title ?? '-',
                    windowSessionId: selection.sessionId ?? '-',
                    tabTitle: MovieCardTabTitle.About,
                    badgeType,
                });
            },
            cardViewed(
                position: number,
                contentId: string,
                title: string,
                badgeType: PromoOfferBadgeType
            ) {
                eventSender.sendOnce(selectionMovieImpressionWithCardShowedV2, {
                    uuid: contentId ?? '-',
                    title: title ?? '-',
                    entityType: SelectionImpressionEntity.MovieIcon,
                    cardPosition: normalizeItemPosition(position),
                    selectionId: selection.key ?? '-',
                    selectionName: selection.title ?? '-',
                    windowSessionId: selection.sessionId ?? '-',
                    badgeType,
                });
            },
        };
    },
});
